<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router';

import { useAttrs } from 'vue';

import KBtn from '@/components/btns/KBtn.vue';
import KTooltip from '@/components/tooltips/KTooltip.vue';

defineOptions({
  inheritAttrs: false,
});

const props = withDefaults(defineProps<Props>(), {});
export interface Props {
  to: RouteLocationRaw;
}

const attrs = useAttrs();
</script>

<template>
  <span>
    <KTooltip location="top" :offset="0" data-testid="openJobDetailsIconLink">
      <div>Open job details</div>
      <template #activator="{ props: tooltipProps }">
        <KBtn
          :active="false"
          v-bind="{ ...tooltipProps, ...attrs }"
          :class="$style.openJobDetailsIconLink"
          variant="text"
          size="xs"
          icon="mdi-open-in-app"
          rounded="50"
          :to="props.to"
        />
      </template>
    </KTooltip>
  </span>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.openJobDetailsIconLink {
}
</style>
